import parseQueryString from 'utils/parseQueryString';

export const RESERVE_NOW = 'reserveNow';
export const FOOD_MENU = 'foodMenu';

export const checkRestaurantOpen = () => {
	// restaurant opens 
	// 20 Feb 2025, 10:00 PST
	// 20 Feb 2025, 18:00 UTC
	// const restaurantOpen = Date.now() > Date.UTC(2025, 1, 20, 18);
	const restaurantOpen = true;
	const query = parseQueryString();
	const isLocalOrDemo = __IS_LOCAL__ || __IS_DEMO__;
	if (restaurantOpen || (isLocalOrDemo && query.restaurantOpen)) {
		return true;
	}
	return false;
};

export const checkFoodMenuQuery = () => {
	const query = parseQueryString();
	return query.menu;
};

export const pause = (duration) => new Promise((resolve) => setTimeout(resolve, duration));
